import { docTypes } from "../../@types/common"

export const allLabels = [
    '*',
    'classify',
    'fraud',
    'recognize',
    'face_detect',
    'face_distance',
    'face_selfie',
    'fulltext',
    'fulltext_with_tables',
    'rus_invoices',
    'recognize_general_invoices',
    'demo_rosbank',
    'recognize_stamp_signature',
  ]
  
  export const defaultLabels = [
    '*',
    'classify',
    'fraud',
    'recognize',
    'face_detect',
    'face_distance',
    'face_selfie',
    'fulltext',
    'fulltext_with_tables',
    'rus_invoices',
    'recognize_general_invoices',
    'demo_rosbank',
    'recognize_stamp_signature',
  ]
  
  export const allHitlLabels = [
    ...docTypes.map((d) => `hitl_doctype_${d}`),
    'hitl_doctype_car_photo',
  ]